<template>
  <div class="complete_content" @click="closeMenu()">
    <dd-header
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>メールアドレス更新確認</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li class="red">※メールアドレスの更新はまだ完了しておりません。</li>
            <li>ご入力いただいたメールアドレスに確認メールを送信いたしました。</li>
            <li>確認メールに記載されたリンクからログインし、更新処理を完了させてください。</li>
          </ul>
          <ul class="for_mail">
            <li>※受信制限をされている方は、「<label class="weighty">@domans.co.jp</label>」からのメールを受信許可に設定してください</li>
            <li>※メールアドレスを間違えて入力してしまった場合は、再度更新手続きを行ってください。</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Module
import Header from '../components/common/DcHeader'

export default {
  name: 'Login',
  components: {
    'dd-header': Header
  },
  data () {
    return {
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdateAccountConfirm.vue